"use client";
import { useKEIConnect } from "../hooks";
import { PropsWithChildren, ReactNode } from "react";
import { LoadingButton, LoadingButtonProps } from "@mui/lab";

export interface KEIConnectButtonProps
  extends PropsWithChildren,
    LoadingButtonProps {
  buttonChildren?: ReactNode;
}

export const KEIConnectButton = ({
  children,
  buttonChildren = "Connect",
  ...props
}: KEIConnectButtonProps) => {
  const connect = useKEIConnect();

  // TODO fix me
  if (!connect.isConnected) {
    return (
      <LoadingButton
        color="primary"
        variant="contained"
        content="test"
        {...props}
        loading={connect.isConnecting || connect.isInitialising}
        onClick={() => connect.connect()}
      >
        {buttonChildren}
      </LoadingButton>
    );
  }

  return children;
};
